import React, { useState, useEffect } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import { numberWithCommas } from "@Components/common/site/common-functions"
import SocialShare from "@Components/Share/SocialShare";
import CustomVideoPlay from "@Components/CustomVideo/CustomVideo.js";
import Modal from "react-bootstrap/Modal"
import BookAViewing from "@Components/BookAViewing/book-a-viewing.js"
import RegisterButton from "../../../Components/Register/RegisterButton";
import "./PropertyDetailsBanner.scss";
import { SaveItem, getUserobjectData, useAuthState, UserObjectStoreProvider } from "@starberry/myaccount-website-utils";
import {
  SALE_PAGE_URL,
  RENT_PAGE_URL
} from "@Components/common/site/constants";
import { useQuery } from '@apollo/client';
import gql from "graphql-tag";
import { navigate } from "@reach/router"
import { inViewOptions } from '../../../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import HTMLReactParser from 'html-react-parser'
export const uknumberformat = (x) => {
  if (!x) return x; 
  const currentValue = x.toString().replace(/[^\d]/g, '');
  return `${currentValue.slice(0, 5)} ${currentValue.slice(5, 11)}`; 
}
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const titleVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    delay: 0.4,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const contentVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    delay: 1,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 1
    }
  }
}

const GET_ALL_TEAMS = gql`
  query GetTeam{
    teams(where: {Publish:true}, sort: "createdAt:asc") {
      id
      imagetransforms
      ggfx_results {
        id
        content_type
        transforms
        src_import_url
        src_cftle
        field
      }
      Repeat_Id
      Name
      Designation
      Email
      Phone
      Book_A_Video
      Image {
        alternativeText
        url
      }
    }
  }
`
const PropertyDetailsBanner = (props) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (event) => {
    setShow(true);
  }
  const backclick = () => {
      if(sessionStorage.getItem('tabType') === 'map' && props.data?.search_type === "lettings"){
        navigate(`/property-map/to-rent/in-oxford-and-thame/`)
      }
      else if(sessionStorage.getItem('tabType') === 'map' && props.data?.search_type === "sales"){
        navigate(`/property-map/for-sale/in-oxford-and-thame/`)
      }
      else if(sessionStorage.getItem('tabType') === 'list' && props.data?.search_type === "lettings"){
        navigate(`/property/to-rent/in-oxford-and-thame/`)
      }
      else if(sessionStorage.getItem('tabType') === 'list' && props.data?.search_type === "sales"){
        navigate(`/property/for-sale/in-oxford-and-thame/`)
      }
      else if(props.data?.search_type === "lettings"){
        navigate(`/property/to-rent/in-oxford-and-thame/`)
      }
      else if(props.data?.search_type === "sales"){
        navigate(`/property/for-sale/in-oxford-and-thame/`)
      }
      else {
        navigate(`/property/for-sale/in-oxford-and-thame/`)
      }
 }
 
 const [userObjects, setUserObjects] = useState({});
 const { state: authState, services: authServices } = useAuthState()
 const isAuthenticated = authServices.isAuthenticated()

  const [negophone, setNegophone] = useState("")
  const { data } = useQuery(GET_ALL_TEAMS)
  useEffect(() => {
    setNegophone(props.data?.crm_negotiator_id?.Telephone?.value)
    if (data && data.teams && data.teams.length > 0 && props.data?.crm_negotiator_id?.ID) {
      for (var i = 0; i < data.teams.length; i++) {
        if (props.data?.crm_negotiator_id?.Email?.value === data.teams[i].Email) {
          setNegophone(data.teams[i].Phone)
        }
        else if (props.data?.crm_negotiator_id?.Name?.value === data.teams[i].Name) {
          setNegophone(data.teams[i].Phone)

        } else if (props.data?.crm_negotiator_id?.ID?.value === data.teams[i].Repeat_Id) {
          setNegophone(data.teams[i].Phone)

        }
      }
    }

    if (isAuthenticated) {
      const getUserObjects = async () => {
          try {
              const userObjects = await getUserobjectData()
              setUserObjects(userObjects.data.data)
          } catch (e) {
              console.log("e:", e)
          }
      }
      getUserObjects()
    }

  }, [data])

  //console.log("propertydetails",props.data)
  return (
    <UserObjectStoreProvider>
    <InView {...inViewOptions}>
      {({ ref, inView }) => {
        return (
          <motion.section
            ref={ref}
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={containerVariants}
          >
            <React.Fragment>
              <section className="property-details-banner">
                <ScrollAnimation animateIn='fadeInUp' animateOnce={true}>
                  <motion.div variants={titleVariants}>
                    <Modal
                      id="share_modal_mobile"
                      show={show}
                      onHide={handleClose}
                      backdrop="static"
                      keyboard={false}
                      size="lg"
                      dialogClassName="modal-90w modal-form"
                    >
                      <Modal.Header closeButton className="contact-close-btn memberPopup">
                        <Modal.Title className="w-100"><h6 className="text-center content-primary-color mb-0 text-uppercase">Request a viewing</h6></Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <BookAViewing price={props.price} image={props.image} officeNumber={props.officeNumber} handleClose={handleClose} search_type={props.search_type} url={props.pageurl} address={props.data?.display_address} office_crm_id={props?.data?.office_crm_id} />
                      </Modal.Body>
                    </Modal>
                  </motion.div>

                  <motion.div variants={contentVariants}>
                    <Container>
                      <Row>
                        <Col lg={9}>
                          <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                            <div className="back-button-wrap"><a href="javascript:void(0)"
                            // to={props.data?.search_type === "lettings" ? RENT_PAGE_URL.alias : SALE_PAGE_URL.alias}
                            onClick={backclick}
                             className="back-link"><span className="arrow-left-button d-none d-xl-block"><i className="arrow-banner-left"></i></span></a><h1>{HTMLReactParser(props.data?.display_address)}</h1>
                            </div>
                          </ScrollAnimation>
                        </Col>
                        <Col lg={3}>
                          <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                            <div className="button-groups-property-banner d-none d-lg-block">
                            {props?.crm_provider == "jet" && <RegisterButton Type={props?.search_type} UniqueID={props?.crm_id}  className="btn btn-primary"/>}
                              <a href="javascript:void(0)" onClick={handleShow} className="btn btn-primary">Request a viewing</a>
                              {
                              props.search_type === "lettings" ?
                              <Link href={"tel:" + '01865 722722'} className="btn btn-outline"><i class="icon-phone-menu"></i> Call {uknumberformat('01865 722722')}</Link> 
                              :
                              negophone ? <Link href={"tel:" + negophone} className="btn btn-outline"><i class="icon-phone-menu"></i> Call {uknumberformat(negophone)}</Link> : null}
                            </div>
                          </ScrollAnimation>
                        </Col>
                      </Row>
                      <Row>
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <Col xs={12}>
                            <div className="item-price">{props.data?.search_type === "sales" ? props.data.price_qualifier.replace(/\b\w/g, char => char.toUpperCase())+' ' : ''} &#163;<span className="price">{numberWithCommas(props.data?.price)} {props.data?.search_type === "lettings" ? " PCM" : null}</span></div>
                          </Col>
                        </ScrollAnimation>
                      </Row>
                      <Row>
                        <Col xs={8} md={7} xl={9} className="pr-xs-0">
                          <div className="amenities-block">
                            <ul>
                              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                <li><i className="icon-bed"></i> {props.data?.bedroom} <span className="text-amenities d-none d-lg-block">Bedroom{props.data?.bedroom > 1 ? "s" : ""}</span></li>
                                <li><i className="icon-bathroom"></i> {props.data?.bathroom} <span className="text-amenities d-none d-lg-block">Bathroom{props.data?.bathroom > 1 ? "s" : ""}</span></li>
                                {props.data?.reception > 0 ? <li><i className="icon-reception"></i> {props.data?.reception} <span className="text-amenities d-none d-lg-block">Reception{props.data?.reception > 1 ? "s" : ""}</span></li> : null}
                              </ScrollAnimation>
                            </ul>
                          </div>
                          {props.data?.studentProperty ?
                          <> 
                          <div className="status-blk">
                          Student Property
                          </div>
                          {props.data?.status ? 
                          <div className="status-blk black">
                          {props.data?.status}
                          </div>
                          : null}
                          </>
                          : props.data?.status ? 
                          <div className="status-blk">
                          {props.data?.status}
                          </div>
                          : null}
                          
                        </Col>
                        <Col xs={4} md={5} xl={3}>
                          <div className="share-block">
                            <ul>
                              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                <li>
                                    <SaveItem type="property" pid={props.data.id} userObjects={userObjects} loaderEnable={false} >
                                    <span className="icon-round-box wishlist">
                                      <span className="icon-wrap">
                                        <i class="icon-wishlist-small icon-default"></i>
                                        <i class="icon-wishlist-small icon-fill icon-saved"></i>
                                      </span>
                                      <span className="icon-text save-text">Save</span>
                                      <span className="icon-text saved-text">Saved</span>
                                    </span>
                                  </SaveItem>
                                </li>
                                {/* <li className="d-inline-flex d-md-none">
                                     <CustomVideoPlay small={true} title={props.data.title} url={props.data.virtual_tour}/>
                                </li> */}
                                {/* <li><i className="icon-wishlist-small"></i> <span className="text-amenities d-none d-md-block">Save Property</span></li> */}
                                <li><SocialShare data={props.data} propDetails={true} Title="Share" />
                                  {/* <i className="icon-share"></i> <span className="text-amenities d-none d-md-block">Share</span> */}
                                </li>
                              </ScrollAnimation>

                            </ul>
                          </div>
                          <div className="custom-video-play d-block d-md-none">            
                            <CustomVideoPlay small={true} title={props.data.title} url={props.data.virtual_tour}/>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </motion.div>
                </ScrollAnimation>
              </section>
            </React.Fragment>
          </motion.section>
        )
      }}
    </InView>
    </UserObjectStoreProvider>
  )
}

export default PropertyDetailsBanner;
